<div
  id="antipattern-popup"
  class="coachbot-all-antipattern-popup coachbot-all-antipattern-popup-show"
>
  <div class="coachbot-all-antipattern-popup-header">
    <button class="coachbot-all-antipattern-popup-close_button" (click)="close()"></button>
  </div>
  <div
    class="coachbot-all-antipattern-popup-content"
    id="popup-content"
    *ngIf="isFeedbackStageNotForm$ | async"
  >
    <div
      class="coachbot-antipattern-popup-banner"
      [ngStyle]="{
        background: hexToRgba(data.configuration.pillTextColor, 0.15),
        color: data.configuration.pillTextColor,
        border: '1px solid ' + data.configuration.pillTextColor
      }"
    >
      <img
        *ngIf="isAntipatternDetected"
        src="{{ assetsPath$ | async }}/icons/warning-icon.svg"
        height="auto"
        width="auto"
      />
      <span>{{ data.configuration.name }}</span>
    </div>
    <div class="coachbot-all-antipattern-popup-description_text">
      {{ data.configuration.subtitle }}
    </div>
    <div class="coachbot-all-antipattern-popup-video_container">
      <video
        #videoPlayer
        class="coachbot-all-antipattern-popup-video"
        controls
        id="coachbot-popup-video"
        [style.opacity]="playButtonClicked ? 1 : 0"
      >
        <source [src]="data.configuration.videoURL" type="video/mp4" />
      </video>
      <div
        class="coachbot-all-antipattern-popup-overlay_video"
        *ngIf="!playButtonClicked"
      ></div>
      <img
        class="coachbot-all-antipattern-popup-play_button"
        src="https://alpha-coach-bot-students-assets.s3.amazonaws.com/readTheory/video-overlay.svg"
        alt="Play"
        (click)="onPlayButtonClicked()"
        *ngIf="!playButtonClicked"
      />
    </div>
    <div
      class="coachbot-all-antipattern-popup-description_text"
      [innerHTML]="processedDescription"
    ></div>
  </div>
  <ap-feedback
    [banner]="{ color: hexToRgba(data.configuration.pillTextColor, 0.15) }"
    [configuration]="data.configuration"
    [notificationId]="data.notificationId"
    [processedDescription]="processedDescription"
    [stage]="feedbackStage"
    [type]="data.configuration.type"
    (onStageChange)="changeFeedbackStage($event)"
  />
</div>
